import sweetalert from 'sweetalert';
import { obtenerIdiomaActual } from '../context/IdiomaContext';
import { traducirTexto } from './catalogo';

const traducir = (valor) => traducirTexto(valor, obtenerIdiomaActual());

// Conserva la API original de sweetalert y localiza tanto las llamadas
// posicionales como los objetos de configuración, incluidos mensajes del API.
export default function swal(...argumentos) {
  const localizados = argumentos.map((argumento) => {
    if (typeof argumento === 'string') return traducir(argumento);
    if (!argumento || typeof argumento !== 'object' || Array.isArray(argumento)) return argumento;
    const configuracion = { ...argumento };
    ['title', 'text', 'content', 'button'].forEach((clave) => {
      if (typeof configuracion[clave] === 'string') configuracion[clave] = traducir(configuracion[clave]);
    });
    if (configuracion.buttons && typeof configuracion.buttons === 'object') {
      configuracion.buttons = Object.keys(configuracion.buttons).reduce((botones, clave) => {
        const boton = configuracion.buttons[clave];
        botones[clave] = typeof boton === 'string'
          ? traducir(boton)
          : boton && typeof boton === 'object'
            ? { ...boton, text: traducir(boton.text) }
            : boton;
        return botones;
      }, {});
    }
    return configuracion;
  });
  return sweetalert(...localizados);
}
